import React, { useState, useEffect,Suspense  } from 'react';
import Plot from 'react-plotly.js';
import {fetchMarketOptions} from "../../api";
import option_stocks from '../../resources/stock_mf_list.json';
import stocklist from "../../resources/stock_mf_list.json";
import "./optionStrategy.css"

// Approximation of the error function (erf)
function erf(x) {
  const sign = x >= 0 ? 1 : -1;
  const a1 = 0.254829592;
  const a2 = -0.284496736;
  const a3 = 1.421413741;
  const a4 = -1.453152027;
  const a5 = 1.061405429;
  const p = 0.3275911;

  const absX = Math.abs(x);
  const t = 1.0 / (1.0 + p * absX);
  const y = 1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-absX * absX);

  return sign * y;
}

// Cumulative normal distribution function using erf approximation
function cumulativeNormalDistribution(x) {
  return 0.5 * (1 + erf(x / Math.sqrt(2)));
}

// Probability density function for normal distribution
function normalPDF(x) {
  return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * x * x);
}


// Black-Scholes formula for call and put options
const blackScholes = (S, K, T, r, sigma, optionType,metric) => {
  const d1 = (Math.log(S / K) + (r + (sigma ** 2) / 2) * T) / (sigma * Math.sqrt(T));
  const d2 = d1 - sigma * Math.sqrt(T);
  // const N = (x) => (1.0 + Math.erf(x / Math.sqrt(2))) / 2; // Approximation for the cumulative normal distribution
  const N = (x) => cumulativeNormalDistribution(x);
  const N_ = (x) => normalPDF(x);

  if (optionType === "call") {
    if (metric === "price") {
        // console.log(optionType,metric)
        return S * N(d1) - K * Math.exp(-r * T) * N(d2);
    }
    if (metric === "delta") {return N(d1);}
    if (metric === "gamma") {return N_(d1)/(S * sigma * Math.sqrt(T));}
    if (metric === "vega") {return S * N_(d1) * Math.sqrt(T);}
    if (metric === "theta"){ return -S * N_(d1) * sigma/(2 * Math.sqrt(T)) - r * K * Math.exp(-r * T) * N(d2);}
    if (metric === "rho") {return K * T * Math.exp(-r * T) * N(d2);}
  }
  else if (optionType === "put") {
                      // console.log(optionType,metric)
    if (metric === "price") {
                // console.log(optionType,metric)

        return K * Math.exp(-r * T) * N(-d2) - S * N(-d1);
    }
    if (metric === "delta") {return N(d1) - 1;}
    if (metric === "gamma") {return N_(d1)/(S * sigma * Math.sqrt(T));}
    if (metric === "vega") {return S * N_(d1) * Math.sqrt(T);}
    if (metric === "theta") {return -S * N_(d1) * sigma/(2 * Math.sqrt(T)) + r * K * Math.exp(-r * T) * N(-d2);}
    if (metric === "rho") {return -K * T * Math.exp(-r * T) * N(-d2);}
  }
  return 0;
};

const MarketOptionS = ({symbol=""}) => {

  const [symbols, setSymbols] = useState([]);
  const [selectedSymbol, setSelectedSymbol] = useState("");

  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [StrategyComponent, setStrategyComponent] = useState(null);

  const strategies = [
    { value: "BullCallSpread", text: "Bull Call Spread" },
    { value: "BullPutSpread", text: "Bull Put Spread" },
    { value: "IronCondor", text: "Iron Condor" },
    { value: "IronButterfly", text: "Iron Butterfly" },
    // { value: "Straddle", text: "Straddle" },
    // { value: "Strangle", text: "Strangle" },
    // { value: "ButterflySpread", text: "Butterfly Spread" },
    // { value: "LongCall", text: "Long Call" },
    // { value: "LongPut", text: "Long Put" },
    // { value: "CoveredCall", text: "Covered Call" },
    // { value: "ProtectivePut", text: "Protective Put" },
  ];
  useEffect(() => {
    // Simulate fetching symbols from API
    setSymbols(stocklist.option_stocks);
  }, []);

    useEffect(() => {
    if (symbol && symbol !== selectedSymbol) {
      setSelectedSymbol(symbol);
    }
  }, [symbol, selectedSymbol]); // Only update when symbol changes

    const handleStrategyChange = async (strategy) => {
    setSelectedStrategy(strategy);
    try {
      const module = await import(`./${strategy}`);
      setStrategyComponent(() => module.default);
    } catch (error) {
      console.error("Error loading strategy module:", error);
    }
  };

    const handleSymbolChange = (e) => {
    const newSymbol = e.target.value;
    // alert("handle symbol change ..selected symbol is " + newSymbol)
        setSelectedSymbol(newSymbol);
        // fetchOptions(newSymbol)
        // setSelectedExpiry(""); // Reset expiry dropdown
        // setFilteredOptions([]); // Clear strikes
        // setLowerStrike(""); // Reset lower strike
        // setHigherStrike(""); // Reset higher strike
    };

  return (
  <div className="os_parent-container" >
        {/* Top Row for Symbol and Expiry */}
      <div className="top-row">
        <div>
          <label>Strategy</label>
          <select onChange={(e) => handleStrategyChange(e.target.value)} value={selectedStrategy || ""}>
            <option value="">Select a Strategy</option>
              {strategies.map((strategy) => (
                <option key={strategy.value} value={strategy.value}>
                  {strategy.text}
                </option>
              ))}

          </select>
        </div>
        {symbol.length > 0 ? "" :
        <div>
          <label>Symbol:</label>
          <select onChange={handleSymbolChange} value={selectedSymbol}>
            <option value="">Select Symbol</option>
            {symbols.map((symbol) => (
              <option key={symbol.symbol} value={symbol.symbol}>
                {symbol.symbol}
              </option>
            ))}
          </select>
        </div>
        }
      </div>
      <div>
        {StrategyComponent && selectedSymbol ? (
          <Suspense fallback={<p>Loading...</p>}>
            <StrategyComponent key={selectedSymbol} symbol={selectedSymbol}/>
          </Suspense>
        ) : (
          <p>Select a strategy to view details.</p>
        )}
      </div>
      </div>
  );
};
export default MarketOptionS;
